"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PlaybookInfoContainer = function PlaybookInfoContainer(_ref) {
  var description = _ref.description,
    riskScoreBar = _ref.riskScoreBar,
    children = _ref.children;
  if (children) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex flex-col gap-2 rounded-2xl p-2 bg-background-primary-canvas my-1",
      children: children
    });
  }
  if (!description && !riskScoreBar) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2 rounded-2xl p-2 bg-background-primary-canvas my-1",
    "data-sentry-component": "PlaybookInfoContainer",
    "data-sentry-source-file": "PlaybookInfoContainer.tsx",
    children: [description && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "font-normal text-sm leading-[150%] text-[#6B7280] p-2",
      children: description
    }), riskScoreBar]
  });
};
var _default = exports.default = PlaybookInfoContainer;